import { useEffect } from 'react';
import { useUserDefine } from '../context/UserDefineContext';
import { DEFAULT_LABELS } from '../constants/columnConstants';

// Looks up whether a column (matched by its stable ColNo) should be shown,
// based on the saved ColToBeAsk (1/0) for the given book BookName.
// (e.g. 'SALE', 'PURC', 'CHAL', 'CREDIT', 'DEBIT', 'QUOT', 'SORDER', 'PORDER', 'PCHAL', 'PROFORMA').
// If no config rows exist yet for that BookName, or the field isn't present in
// the saved config, it defaults to visible so nothing breaks before a user
// has configured columns for that book type.
export const useVisibleColumns = (bookName) => {
    const { userDefineData, refetchUserDefineData } = useUserDefine();
    const rows = userDefineData?.[bookName] || [];

    // Refetch on mount so opening a module always reflects the latest
    // UserDefineColumns save, without needing a full page reload.
    useEffect(() => {
        refetchUserDefineData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookName]);

    console.log(
        `[useVisibleColumns:${bookName}] visibility list:`,
        rows.map(r => ({ ColNo: r.ColNo, ColName: r.ColName, ColToBeAsk: Boolean(r.ColToBeAsk) }))
    );

    // Match by ColNo (stable numeric id), not ColName (mutable string label)
    const isColVisible = (colNo) => {
        if (!rows.length) return true;
        const row = rows.find(r => r.ColNo === colNo);
        return row ? Boolean(row.ColToBeAsk) : true;
    };

    // Get the full row data by ColNo
    const getColRow = (colNo) => rows.find(r => r.ColNo === colNo);

    // Get the display label (custom if set via DisplayLabel, else default English)
    const getColLabel = (colNo, fallbackLabel) => {
        const row = getColRow(colNo);
        if (!row) return fallbackLabel || DEFAULT_LABELS[colNo] || '';
        return row.DisplayLabel || row.OthColName || fallbackLabel || DEFAULT_LABELS[colNo] || '';
    };

    return { isColVisible, getColRow, getColLabel };
};
